import useGeographicalFocus, {
  type GeographicalFocusFund,
  type GeographicalFocusSchema
} from '../../../hooks/useGeographicalFocus';
import { Table } from '../../Table';
import { StyledTables } from '../style';
import { TableComponentProps } from '../types';

export function GeographicalFocus({
  funds,
  currentDataKey,
  onChangeFund,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps<
  Record<string, GeographicalFocusFund>,
  Record<'GEOGRAPHICAL_FOCUS', GeographicalFocusSchema>
>) {
  const { columns, onChange, tables } = useGeographicalFocus({
    data: funds[currentDataKey]?.fund_data?.GEOGRAPHICAL_FOCUS,
    onChangeFund,
    schema: schema.GEOGRAPHICAL_FOCUS,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.GEOGRAPHICAL_FOCUS?.field_names || [],
    funds,
    isMultiFunds
  });
  return (
    <StyledTables id="fca-reporttables-geographical-focus-group">
      {tables.map((rows, index) => (
        <Table
          id={`fca-reporttables-geographical-focus-table-${index + 1}`}
          key={index + 'GEOGRAPHICAL_FOCUS'}
          handleChanges={onChange}
          columns={columns}
          rows={rows}
          stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
        />
      ))}
    </StyledTables>
  );
}
